import * as React from "react";

import { useDomainServices } from "@/providers/DomainServices";
import { FileRecord } from "@/shared/domain/files";
import { linkTarget } from "@/shared/domain/files/linkTarget";

export function useGetFileContents() {
  const { files: fileService } = useDomainServices();

  return React.useCallback(
    function getFileContentsAsUrl(
      file: FileRecord,
      options?: Partial<{
        forDownload: boolean;
        abortSignal: AbortSignal;
      }>,
    ) {
      const { abortSignal, forDownload = false } = options || {};
      // For a link, signs a URL for the file it points to.
      return fileService.getPresignedDownloadUrl(linkTarget(file).fileId, {
        // Add extra search params to support downloads as attachments
        searchParams: fileService.getSignedUrlParams(file, forDownload),
        abortSignal,
      });
    },
    [fileService],
  );
}
